var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 1.78735C8.1903 1.78735 8.36411 1.89539 8.44835 2.06604L10.3921 6.00392L14.739 6.63928C14.9273 6.6668 15.0836 6.7988 15.1423 6.9798C15.201 7.16081 15.1518 7.35943 15.0155 7.4922L11.8706 10.5554L12.6128 14.8828C12.645 15.0704 12.5679 15.26 12.4139 15.3719C12.2599 15.4837 12.0557 15.4985 11.8873 15.4099L7.99999 13.3656L4.11272 15.4099C3.94426 15.4985 3.74012 15.4837 3.58613 15.3719C3.43214 15.26 3.35502 15.0704 3.38719 14.8828L4.1294 10.5554L0.984461 7.4922C0.848152 7.35943 0.799016 7.16081 0.857704 6.9798C0.916393 6.7988 1.07273 6.6668 1.26101 6.63928L5.60786 6.00392L7.55164 2.06604C7.63588 1.89539 7.80968 1.78735 7.99999 1.78735ZM7.99999 3.41698L6.38835 6.682C6.31558 6.82942 6.17499 6.93165 6.01231 6.95543L2.40753 7.48232L5.01553 10.0225C5.13346 10.1374 5.1873 10.3029 5.15947 10.4652L4.54409 14.0532L7.76727 12.3581C7.91296 12.2815 8.08703 12.2815 8.23272 12.3581L11.4559 14.0532L10.8405 10.4652C10.8127 10.3029 10.8665 10.1374 10.9845 10.0225L13.5925 7.48232L9.98768 6.95543C9.825 6.93165 9.68441 6.82942 9.61164 6.682L7.99999 3.41698Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6b283be03d6e6317ea69e88515e6c1ee.svg";
export { ForwardRef as ReactComponent };